import jQuery from 'jquery';
import * as Cookie from '../../../util/cookie';
import { settings as mainSettings } from '../../main/config';
import { settings } from '../config';

export default async function initialize() {
	let tabs = jQuery('.home-tabs a');
	if (tabs.length > 0) {
		tabs.on('click', e => {
			const href = jQuery(e.currentTarget).attr('href');

			if (href) {
				const hash = href.replace('#', '#!');
				window.history.pushState(null, null, hash);
	
				setHomeTabCookie(hash);
			}
		});

		window.addEventListener('popstate', async () => {
			await loadTab();
		});

		await loadTab();
	}
}

async function loadTab() {
	let hash = window.location.hash || Cookie.get(settings.cookieNames.homeTab) || '';
	let activeTab = jQuery(`.home-tabs a[href="${hash.replace('#!', '#')}"]`);
	if (activeTab.length) {
		window.location.hash = hash;
		setHomeTabCookie(hash);
		activeTab.tab('show');
	}
	else {
		jQuery('.home-tabs a:first').tab('show');
	}
}

function setHomeTabCookie(value: string) {
	Cookie.set(settings.cookieNames.homeTab, value, {
		path: mainSettings.applicationPath
	});
}
